// extracted by mini-css-extract-plugin
export default {"scroll":"SurveyReportsEditor_scroll__3m-rp"};